export function pxToRem(value) {
  return `${value / 16}rem`
}

export function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  }
}

const displayFamily = '"Space Grotesk", sans-serif'
const bodyFamily = '"Manrope", sans-serif'

export const typography = {
  fontFamily: bodyFamily,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: displayFamily,
    fontWeight: 700,
    fontSize: pxToRem(36),
    lineHeight: 56 / 48,
    letterSpacing: '-0.02em',
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h2: {
    fontFamily: displayFamily,
    fontWeight: 600,
    fontSize: pxToRem(28),
    lineHeight: 36 / 28,
    letterSpacing: '-0.01em',
    ...responsiveFontSizes({ sm: 30, md: 31, lg: 32 }),
  },
  h3: {
    fontFamily: displayFamily,
    fontWeight: 600,
    fontSize: pxToRem(24),
    lineHeight: 32 / 24,
    letterSpacing: '-0.01em',
  },
  h4: {
    fontFamily: displayFamily,
    fontWeight: 600,
    fontSize: pxToRem(24),
    lineHeight: 32 / 24,
    letterSpacing: '-0.01em',
  },
  h5: {
    fontFamily: displayFamily,
    fontWeight: 600,
    fontSize: pxToRem(20),
    lineHeight: 28 / 20,
    letterSpacing: '-0.01em',
  },
  subtitle1: {
    fontFamily: bodyFamily,
    fontWeight: 600,
    fontSize: pxToRem(14),
    lineHeight: 20 / 14,
    letterSpacing: '0.01em',
  },
  subtitle2: {
    fontFamily: bodyFamily,
    fontWeight: 700,
    fontSize: pxToRem(12),
    lineHeight: 16 / 12,
    letterSpacing: '0.01em',
  },
  body1: {
    fontFamily: bodyFamily,
    fontWeight: 400,
    fontSize: pxToRem(16),
    lineHeight: 24 / 16,
  },
  body2: {
    fontFamily: bodyFamily,
    fontWeight: 400,
    fontSize: pxToRem(14),
    lineHeight: 20 / 14,
  },
  button: {
    fontFamily: bodyFamily,
    fontWeight: 700,
    fontSize: pxToRem(14),
    lineHeight: 20 / 14,
    letterSpacing: '0.01em',
  },
  caption: {
    fontFamily: bodyFamily,
    fontWeight: 700,
    fontSize: pxToRem(12),
    lineHeight: 16 / 12,
    letterSpacing: '0.01em',
  },
  overline: {
    fontFamily: bodyFamily,
    fontWeight: 600,
    fontSize: pxToRem(12),
    lineHeight: 16 / 12,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
}
